export default __webpack_public_path__ + "static/media/winter_isar.29e2d4af.webp";